<template>
  <div class="camera-chart2">
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :lg="12" :xl="12">
        <a-card :loading="loading" class="card-item">
          <div class="flex-align-center">
            <span style="margin-right: 5px">今日抓拍学生量</span>
            <span class="title-1" style="font-size: 22px">{{ chartData.todayStudentCount }}</span>
          </div>
          <mini-area
            :dataSource="chartData.studentList"
            :chartConfig="{
              height: 200,
              padding: [40, 40, 40, 40],
            }"
            :showXAxis="true"
            y="抓拍学生量"
          />
        </a-card>
      </a-col>
      <a-col :sm="24" :md="12" :lg="12" :xl="12">
        <a-card :loading="loading" class="card-item">
          <div class="flex-align-center">
            <span style="margin-right: 5px">今日相机采集量</span>
            <span class="title-1" style="font-size: 22px">
              {{ chartData.todayStudentFaceCount }}
            </span>
          </div>
          <mini-area
            :data-source="chartData.studentFaceList"
            :chartConfig="{
              height: 200,
              padding: [40, 40, 40, 40],
            }"
            :showXAxis="true"
            y="相机采集量"
          />
        </a-card>
      </a-col>
    </a-row>
    <div class="table-card">
      <div class="title-1" style="margin-bottom: 15px">设备运行情况</div>
      <a-table
        ref="table"
        size="middle"
        bordered
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      />
    </div>
  </div>
</template>

<script>
import ChartCard from '@/components/ChartCard'
import MiniArea from '@/components/chart/MiniArea'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@api/manage'

export default {
  name: 'CameraChart2',
  mixins: [JeecgListMixin],
  components: {
    ChartCard,
    MiniArea,
  },
  data() {
    return {
      loading: false,
      total: {},
      chartData: {
        todayStudentFaceCount: 0,
        todaySmsPushCount: 0,
        todayStudentCount: 0,
        studentFaceList: [],
        smsPushList: [],
        studentList: [],
        emoteList: [],
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '设备编号',
          align: 'center',
          dataIndex: 'serialNo',
        },
        {
          title: '安装位置',
          align: 'center',
          dataIndex: 'cameraName',
        },
        {
          title: '最新上报时间',
          align: 'center',
          dataIndex: 'lastReportTime',
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          customRender: (_, record) => {
            return record.status == '1' ? (
              <a-tag color="green">在线</a-tag>
            ) : (
              <a-tag color="red">离线</a-tag>
            )
          },
        },
      ],
      url: {
        list: '/gdCamera/list',
      },
    }
  },
  created() {
    this.getCardListData()
  },
  methods: {
    // 获取卡片列表数据
    getCardListData() {
      this.loading = true
      Promise.all([
        getAction('/home/faceTop'),
        getAction('/home/studentFaceTop'),
        getAction('/home/messageTop'),
      ])
        .then(([faceRes, studentRes, messageRes]) => {
          // 照片采集量
          if (faceRes.success) {
            this.chartData.todayStudentFaceCount = faceRes.result?.[6]?.y || 0
            this.chartData.studentFaceList = faceRes.result
          }
          // 抓拍学生量
          if (studentRes.success) {
            this.chartData.todayStudentCount = studentRes.result?.[6]?.y || 0
            this.chartData.studentList = studentRes.result
            console.log('学生抓拍信息：', studentRes.result)
          }
          // 消息推送量
          if (messageRes.success) {
            this.chartData.todaySmsPushCount = messageRes.result?.[6]?.y || 0
            this.chartData.smsPushList = messageRes.result
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.camera-chart2 {
  .card-item {
    height: 270px;
    border-radius: 10px;
  }
  /deep/ .antv-chart-mini {
    position: relative;
    height: 100%;
    width: 100%;
    .chart-wrapper {
      position: relative;
      bottom: 0;
      width: 100%;
    }
  }
  .table-card {
    padding: 25px 20px;
    margin-top: 20px;
    background-color: #fff;
    border-radius: 10px;
  }
}
</style>
